export default __webpack_public_path__ + "static/media/d15de03890aff39ef0ba07c10c72bbb5.svg";